import { render, staticRenderFns } from "./ContactDataPanel.vue?vue&type=template&id=ff0bca4a&scoped=true"
import script from "./ContactDataPanel.vue?vue&type=script&lang=js"
export * from "./ContactDataPanel.vue?vue&type=script&lang=js"
import style0 from "./ContactDataPanel.vue?vue&type=style&index=0&id=ff0bca4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0bca4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VExpansionPanelContent,VIcon})
